import axios from "axios";

export const postDetailsKonfirmasi = async (formData) => {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}/etle/api/details_konfirmasi.php`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const getCekPembayaran = async (noRef, platNo) => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/data_status_pembayaran.php`,
    {
      params: {
        no_ref: noRef,
        plat_no: platNo,
      },
    }
  );
};

export const getImgCrossOrigin = async (url_img) => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/getImage.php?imageUrl=` +
      url_img,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getProxyImg = async (url_img) => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/admin-etle/proxy-image.php?url=` +
    encodeURIComponent(url_img),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const getDetailKonfirmasi = async (noRef, platNo) => {
  return await axios.get(
    `${process.env.VUE_APP_API_URL}/etle/api/detail_konfirmasi.php`,
    {
      params: {
           no_ref: noRef,
           plat_no: platNo,
      },
    }
  );
};

// export const getBlankoPdf = async (refNumber, plates) => {
//   return await axios.get(
//    ` ${process.env.VUE_APP_API_URL}/etle/admin-etle/serve_blanko.php`,
//     {
//       params: {
//         ref_number: refNumber,
//         plates: plates,
//       },
//       responseType: "blob",
//     }
//   );
// };
